// The app's own natural sounds (S7): reward machines and the unwrap moment, from Stable Audio Open
// takes auto-picked like the places' (art/places/app/sounds.json → public/places/app/). A cue with
// a picked file plays it; anything else (no pick yet, offline before it's cached, sound off) plays
// the synth fallback the app already had.
import { useSettings } from '../data/settings'

let picks: Record<string, { file?: string }> | null = null
let loading: Promise<void> | null = null

function load(): Promise<void> {
  loading ??= fetch('/places/app/sound-picks.json')
    .then((r) => (r.ok ? r.json() : { sounds: {} }))
    .then((j: { sounds?: Record<string, { file?: string }> }) => {
      picks = j.sounds ?? {}
    })
    .catch(() => {
      picks = {}
    })
  return loading
}

/** Plays the app cue's picked take, else `fallback` (a synth cue). Never throws. */
export function appSound(cue: string, fallback: () => void) {
  if (!useSettings.getState().sound) return
  const go = () => {
    const file = picks?.[cue]?.file
    if (!file || typeof Audio === 'undefined') return fallback()
    void new Audio(`/${file}`).play().catch(fallback)
  }
  if (picks) go()
  else void load().then(go)
}
